import React from "react";
import { CheckCircle, Tag } from "lucide-react";

const Cart = () => {
  return (
    <div className="custom-science custom-padding pt-80 pb-80 xl-screen-padding font-lato">
      <div className="bg-green-50 border font-lato border-green-200 text-green-700 px-4 py-3 rounded-lg flex justify-between items-center mb-6">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <CheckCircle size={16} />
          Clinical Nutrition Fundamentals has been added to your cart.
        </div>
        <button className="text-green-700 text-sm font-semibold hover:underline">
          Keep Exploring
        </button>
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2 font-merriweather">Cart</h1>
      <p className="text-sm text-gray-500 mb-6 font-lato">1 Course in Cart</p>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <div className="bg-white border rounded-xl p-4 flex gap-4 items-start shadow-sm">
            <img
              src="https://images.unsplash.com/photo-1490645935967-10de6ba17061"
              alt="course"
              className="w-28 h-20 object-cover rounded-lg"
            />
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">
                Clinical Nutrition Fundamentals
              </h3>

              <p className="text-sm text-gray-500 mb-1">
                By Dr. Satish Jadhav
              </p>
              <div className="flex items-center gap-1 text-yellow-500 text-xs mb-2">
                ⭐⭐⭐⭐⭐
                <span className="text-gray-500 ml-1">(1,245 ratings)</span>
              </div>
              <div className="flex gap-4 text-sm font-semibold">
                <button className="text-[#6dbe45] font-bold hover:underline">
                  Remove
                </button>
                <button className="text-[#6dbe45] hover:underline">
                  Save for later
                </button>
              </div>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-gray-900">$299</p>
              <p className="text-sm text-gray-400 line-through">$399</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 border rounded-xl p-5 h-fit shadow-sm">

          <h3 className="text-sm text-black-500 font-semibold mb-2">Total:</h3>

<p className="text-2xl font-extrabold text-black-800">$299.00</p>
          <p className="text-sm text-gray-400 line-through">$399.00</p>

          <p className="text-sm text-red-500 font-semibold mb-4">
            25% off
          </p>
          <button className="w-full bg-[#6dbe45] text-white py-3 rounded-xl font-semibold hover:bg-[#6dbe45] mb-4">
            Checkout
          </button>
          <div>
            <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
              <Tag size={14} />
              Promotions
            </p>

            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Enter Coupon"
                className="flex-1 px-3 py-2 border rounded-lg text-sm outline-none focus:ring-2 focus:ring-green-500"
              />
              <button className="px-4 py-2 bg-gray-200 text-gray-500 rounded-lg text-sm">
                Apply
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Cart;